module.exports = __webpack_public_path__ + "static/scale-model-of-curry-lake-in-tampa-florida-1170f7d673ff5e9b8f04c6ae19893286.png";